"use strict";

exports.__esModule = true;
exports.getMetricsByDimensionCompare = getMetricsByDimensionCompare;

var _getMetricsByDimension = require("./getMetricsByDimension");

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function getSeries(id, series) {
  const values = series.map(data => {
    return data.y;
  });
  const total = values.reduce((total, value) => {
    return parseFloat(total) + parseFloat(value);
  });
  const average = total / series.length;
  return {
    id: id,
    total: total,
    average: average,
    data: series
  };
}

function getMetricsByDimensionCompare(rows, byMetric = "ga:users", byDimension = "ga:date") {
  if (!rows) {
    return false;
  }

  const metric = (0, _getMetricsByDimension.getMetricsByDimension)(rows, byMetric, byDimension);
  const series = metric.data[0].data;
  const s1 = series.slice(0, series.length / 2);
  const s2 = series.slice(series.length / 2, series.length);
  const d2 = s2.map((row, i) => {
    return _extends({}, row, {
      x: s1[i].x
    });
  });
  const primary = getSeries("primary", s1);
  const secondary = getSeries("secondary", d2);
  return _extends({}, metric, {
    "data": [primary, secondary]
  });
}